import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ResponseAvis} from '../../../../../common/services/avis/response-avis.model';
import {ResponseAvisService} from '../../../../../common/services/avis/response-avis.service';
import {DomSanitizer} from '@angular/platform-browser';
import * as FileSaver from "file-saver";
import {AttachmentService} from "@Common/widgets/general/attachments";
import {AttachmentModel} from "@Common/widgets/general/attachments/interfaces/attachment.model";
import {NewlinePipe} from "@Common/widgets/pipes";

@Component({
  selector: 'app-consult-opinion',
  templateUrl: './consult-opinion.component.html',
  styleUrls: ['./consult-opinion.component.scss']
})
export class ConsultOpinionComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: ResponseAvis,
              public dialogRef: MatDialogRef<ConsultOpinionComponent>,
              public sanitizer: DomSanitizer,
              private attachmentSvc: AttachmentService,
              public avisSvc: ResponseAvisService) { }

  ngOnInit(): void {
  }
  close(): void {
    this.dialogRef.close();
  }

  downloadAttachment(fichier) {
    if (fichier) {
      const _attachment = <AttachmentModel> {
        id: fichier.id,
        filename: fichier.filename,
        file: fichier.file
      };
      return this.attachmentSvc
        .download(_attachment)
        .subscribe(v => FileSaver.saveAs(v, _attachment.filename));
    }
  }

    protected readonly NewlinePipe = NewlinePipe;
}
